import { handleActions } from 'redux-actions';
import { combineReducers } from 'redux';
import { setStatusQuestionary, setStatusQuestionarySuccess, setStatusQuestionaryFailure, setStatusQuestionaryIdle } from '../actions';

const set_status_questionary_status = handleActions(
  {
    [setStatusQuestionary.toString()]: (state, action) => 'LOADING',
    [setStatusQuestionarySuccess.toString()]: (state, action) => 'SUCCESS',
    [setStatusQuestionaryFailure.toString()]: (state, action) => 'FAILURE',
    [setStatusQuestionaryIdle.toString()]: (state, action) => 'IDLE',
  },
  'IDLE'
);

export { set_status_questionary_status };
